import React, { useState } from "react";
import { FaShieldAlt, FaExchangeAlt, FaCogs, FaUserShield, FaCalendarAlt, FaLock, FaMinus, FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Footer from "../../../Component/Fooder";
import { motion } from 'framer-motion';
import Healthcare from "../../../assests/service/Healthcare.jpg";

const HealthcareIntegrations = () => {
    const navigate = useNavigate();
    const [openIndex, setOpenIndex] = useState(0);

    return (
        <>
            <div className="w-full bg-gray-50">
                {/* Hero Section */}
                <div
                    className="relative w-full h-[500px] bg-cover bg-center flex flex-col items-center justify-center text-white text-center px-4 mt-2"
                    style={{ backgroundImage: `url(${Healthcare})` }}
                >
                    <div className="absolute inset-0 bg-[rgba(8,3,3,0.7)]  backdrop-blur-none"></div>
                    <motion.div
                        className="relative z-10"
                        initial={{ opacity: 0, x: -100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <h1 className="text-[30px] font-extrabold">Healthcare Interoperability Consulting</h1>
                        <p className="text-lg mt-4 text-white max-w-3xl">
                            We’ll guide you in achieving healthcare interoperability, crafting a strategy to deliver seamless data exchange.
                        </p>
                        <button
                            className="mt-3 px-6 py-3 bg-white text-blue-700 font-semibold rounded-lg hover:bg-gray-200 transition"
                            onClick={() => navigate("/Contact")}
                        >
                            LET’S DISCUSS YOUR NEEDS
                        </button>
                    </motion.div>
                </div>

                <div className="bg-white max-w-full mx-auto py-16 px-6">                {/* How We Can Help Section */}
                    <section className="w-full mx-auto  px-2">
                        <h2 className="text-[30px] font-bold text-center flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">How We Can Help</h2>
                        <p className="text-gray-800 text-center text-sm mt-2">
                            Exchanging healthcare data is critical, but it can be complex. We simplify the process, ensuring smooth integration.
                        </p>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto px-4 mt-4">
                            {helpFeatures.map((feature, index) => (
                                <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-4 text-center hover:scale-105 transition-transform"
                                    initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                    whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                    transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                    viewport={{ once: false, amount: 0.3 }}>
                                    <feature.icon className="text-[#2a627a] text-4xl mx-auto mb-4" />
                                    <h3 className="text-lg text-[#2a627a] font-bold">{feature.title}</h3>
                                    <p className="text-gray-800 text-sm mt-2">{feature.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </section>


                    {/* Key Interoperability Services */}
                    <section className=" py-12">
                        <div className="w-full mx-auto  ">
                            <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">Key Interoperability Services</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4 max-w-5xl mx-auto px-4">
                                {services.map((service, index) => (
                                    <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-4 text-center hover:scale-105 transition-transform"
                                        initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                        whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                        transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                        viewport={{ once: false, amount: 0.3 }}>
                                        <h3 className="text-lg font-bold text-[#2a627a]">{service.title}</h3>
                                        <p className="text-gray-800 text-sm mt-2">{service.description}</p>
                                    </motion.div>
                                ))}
                            </div>
                        </div>
                    </section>

                    {/* Why Choose Us */}
                    <section className="w-full mx-auto ">
                        <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">Why Choose Us?</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-4 max-w-5xl mx-auto px-4">
                            {whyChooseUs.map((item, index) => (
                                <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-6 text-center hover:scale-105 transition-transform"
                                    initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                    whileInView={{ opacity: 1, x: 0 }} // Move to center
                                    transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                    viewport={{ once: false, amount: 0.3 }}>
                                    <h3 className="text-lg font-bold text-[#2a627a]">{item.title}</h3>
                                    <p className="text-gray-800  text-sm mt-2">{item.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </section>
                    {/* Services Section */}
                    <section className="mt-12 w-full  mx-auto">
                        {/* Heading */}
                        <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                            Discover Our Services
                        </h2>

                        {/* Service List */}
                        <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                            {List.map((service, index) => (
                                <div key={index} className="border-b border-gray-800">
                                    {/* Service Title */}
                                    <button
                                        className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                        onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                    >
                                        {service.title}
                                        {openIndex === index ? (
                                            <FaMinus className="text-red-500" />
                                        ) : (
                                            <FaPlus className="text-gray-600" />
                                        )}
                                    </button>

                                    {/* Service Description (Expandable with Animation) */}
                                    <motion.div
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                        transition={{ duration: 0.3, ease: "easeInOut" }}
                                        className="overflow-hidden"
                                    >
                                        <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                    </motion.div>
                                </div>
                            ))}
                        </div>
                    </section>



                </div>
                {/* Contact Section */}
                <div className="w-full bg-[#2a627a] text-white py-12 text-center">
                    <h2 className="text-2xl font-bold">Ready to Transform Healthcare?</h2>
                    <p className="mt-2">Let’s collaborate to build seamless and secure healthcare solutions.</p>
                    <button
                        className="mt-4 px-6 py-3 bg-gray-300 text-[#2a627a] font-semibold rounded-lg hover:bg-gray-400 transition"
                        onClick={() => navigate("/Contact")}
                    >
                        Book Your Free Consultation
                    </button>
                </div>
            </div>
            <Footer />
        </>
    );
};

// Data for different sections
const helpFeatures = [
    {
        title: "Project Documentation",
        description: "Receive detailed documentation for easy maintenance.",
        icon: FaShieldAlt
    },
    {
        title: "Integration-Ready Solutions",
        description: "Seamless integration between healthcare systems.",
        icon: FaExchangeAlt
    },
    {
        title: "Intellectual Property",
        description: "You own all code and intellectual rights.",
        icon: FaUserShield
    },
    {
        title: "Post-Launch Support",
        description: "Bug-fixing and support after project completion.",
        icon: FaCogs
    },
    {
        title: "Regulatory Compliance",
        description: "Ensure compliance with healthcare regulations like HIPAA and FHIR.",
        icon: FaCalendarAlt
    },
    {
        title: "Data Security & Privacy",
        description: "Protect sensitive healthcare data with strong encryption and security measures.",
        icon: FaLock
    }
];

const services = [
    { title: "Healthcare Interoperability Strategy", description: "Improve data exchange & client onboarding." },
    { title: "Healthcare Data Mapping", description: "Document workflows for better efficiency." },
    { title: "EHR Integration Planning", description: "Seamlessly integrate with major EHR systems." },
    { title: "Healthcare Interoperability Training", description: "Upskill your team with best practices." },
    { title: "Custom API Development", description: "Develop secure and scalable APIs for seamless data integration." },
    { title: "Healthcare Data Analytics", description: "Leverage data insights to improve patient outcomes and operations." }
];

const whyChooseUs = [
    { title: "Experienced", description: "Handled hundreds of interoperability challenges." },
    { title: "Security First", description: "Adhere to HIPAA and cybersecurity standards." },
    { title: "Exceptional Service", description: "Fast & comprehensive US-based support." },
    { title: "24/7/365 Availability", description: "Support available anytime for critical needs." }
];
const List = [
    
    
        {
            "id": "fhir-001",
            "title": "Contract FHIR Integration Development",
            "description": "Leverage our expertise to develop a robust and scalable FHIR implementation tailored to your organization’s needs. Our contract-based development approach ensures a structured, transparent process while maintaining compliance with industry standards. Whether you require a new FHIR-based system or enhancements to existing integrations, we deliver secure, high-performance solutions designed for seamless interoperability across healthcare ecosystems."
        },
        {
            "id": "fhir-002",
            "title": "Managed FHIR Integration Services",
            "description": "Ensure seamless healthcare data exchange with our fully managed FHIR integration services. From initial development to ongoing maintenance and optimization, we handle the entire lifecycle of your FHIR solutions. Our team provides continuous security updates, performance monitoring, and compliance checks to ensure your integrations remain reliable, efficient, and aligned with evolving healthcare regulations."
        },
        {
            "id": "fhir-003",
            "title": "FHIR Integration Hosting",
            "description": "Deploy your FHIR integrations on a secure, HIPAA-compliant cloud or on-premise infrastructure. Our hosting solutions offer high availability, automated backups, and enterprise-grade security to safeguard patient data. With scalable architecture, your integrations can efficiently handle increasing data loads while ensuring smooth interoperability with EHRs, health information exchanges (HIEs), and third-party applications."
        },
        {
            "id": "fhir-004",
            "title": "FHIR Integration Monitoring",
            "description": "Ensure uninterrupted data exchange and system reliability with our real-time FHIR integration monitoring services. Our proactive approach includes continuous performance tracking, instant error detection, and automated alerts for potential failures. By identifying and resolving issues before they impact operations, we help maintain the integrity and efficiency of your healthcare data workflows."
        },
        {
            "id": "fhir-005",
            "title": "FHIR Implementation Strategy",
            "description": "Develop a customized FHIR adoption strategy that aligns with your organization’s goals and regulatory requirements. Our team conducts a comprehensive assessment of your current systems, identifies integration challenges, and creates a phased implementation plan. Whether you are migrating from legacy systems or enhancing existing workflows, our strategic approach ensures a smooth transition to FHIR-compliant interoperability."
        },
        {
            "id": "fhir-006",
            "title": "FHIR Integration Development Consulting",
            "description": "Gain expert guidance on designing, implementing, and optimizing FHIR integrations tailored to your business needs. Our consulting services cover everything from architecture planning and API development to security compliance and system performance optimization. Whether you're integrating with EHRs, health information exchanges (HIEs), or third-party healthcare applications, we provide strategic insights to streamline your implementation process and maximize interoperability."
        }
    ]
    
    


export default HealthcareIntegrations;
